/**
 * Check if URL is absolute
 * @category Helper
 * @param url
 * @returns
 */
export function isAbsoluteUrl(url) {
    return /^https?:\/\//.test(url);
}
//# sourceMappingURL=isAbsoluteUrl.js.map